<script setup lang="ts">
const props = defineProps({
  amount: {
    type: Number,
    required: true,
  },
  total: {
    type: Number,
    required: true,
  },
  scale: {
    type: Number,
    required: false,
    default: 1
  },
  points: {
    type: String,
    required: false,
    default: 'M10.667,14.181l4.12,2.487-1.093-4.687,3.64-3.154L12.541,8.42,10.667,4,8.794,8.42,4,8.827l3.64,3.154L6.547,16.668Z'
  },
  colorActive: {
    type: String,
    required: false,
    default: '#ffab05',
  },
  colorBack: {
    type: String,
    required: false,
    default: '#0000007e',
  }
})

const counter = (amount: number, total: number) => `${((amount / total) * 100).toFixed(2)}%`
const sizer = (total: number) => total * 15.3 * props.scale
</script>

<template>
  <div class="relative mb-3 -ml-1">
    <div :style="{ width: sizer(total)+'px' }" class="absolute">
      <div :style="{ 
        width: counter(amount, total),
        background: colorActive,
        height: `${16 * scale}px`
      }" class="fill-star inset-0" />
    </div>
    <svg :width="sizer(total)" :height="16 * scale" class="-z-10">
      <path
        v-for="elem in total"
        :key="elem"
        :d="points"
        :transform="`translate(${(elem - 1) * 15 * scale} 0) scale(${scale})`"
        :fill="colorBack"
      />
      <clipPath id="stars--mark">
        <path
          v-for="elem in total"
          :key="elem"
          :d="points"
          :transform="`translate(${(elem - 1) * 15 * scale} 0) scale(${scale})`"
        />
      </clipPath>
    </svg>
  </div>
</template>

<style lang="scss">
.fill-star {
  -webkit-clip-path: url(#stars--mark);
  clip-path: url(#stars--mark);
}
.star {
  transform: scale(2);
  -ms-transform: scale(2);
  -webkit-transform: scale(2);
}
</style>
